var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', _vm._b({
    class: `autcomplete-applications-${_vm.className}`,
    attrs: {
      "items": _vm.applications,
      "menuProps": {
        attach: `.autcomplete-applications-${_vm.className}`
      },
      "multiple": "",
      "return-object": "",
      "item-value": "_id"
    },
    on: {
      "change": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref) {
        var _item$resume, _item$resume$personal, _item$resume2, _item$resume2$persona, _item$resume3, _item$resume3$persona;
        var item = _ref.item,
          parent = _ref.parent;
        return [_c('v-chip', {
          attrs: {
            "label": "",
            "outlined": "",
            "close": ""
          },
          on: {
            "click:close": function ($event) {
              return parent.selectItem(item);
            },
            "select": function ($event) {
              return parent.selectItem(item);
            }
          }
        }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$resume = item.resume) === null || _item$resume === void 0 ? void 0 : (_item$resume$personal = _item$resume.personalInformation) === null || _item$resume$personal === void 0 ? void 0 : _item$resume$personal.name) + " / " + _vm._s(item === null || item === void 0 ? void 0 : (_item$resume2 = item.resume) === null || _item$resume2 === void 0 ? void 0 : (_item$resume2$persona = _item$resume2.personalInformation) === null || _item$resume2$persona === void 0 ? void 0 : _item$resume2$persona.genderText) + " / " + _vm._s(item === null || item === void 0 ? void 0 : (_item$resume3 = item.resume) === null || _item$resume3 === void 0 ? void 0 : (_item$resume3$persona = _item$resume3.personalInformation) === null || _item$resume3$persona === void 0 ? void 0 : _item$resume3$persona.age) + " ")])];
      }
    }, {
      key: "item",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('application-card', _vm._b({
          staticClass: "ma-10",
          attrs: {
            "value": item,
            "selectable": "",
            "isSelected": _vm.selected.some(function (_ref3) {
              var _id = _ref3._id;
              return _id == item._id;
            }),
            "width": "100%"
          }
        }, 'application-card', {
          recruitment: _vm.recruitment
        }, false))];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, 'v-autocomplete', _vm.attrs_input, false));

}
var staticRenderFns = []

export { render, staticRenderFns }